import { render } from "./device-big.vue?vue&type=template&id=0121aabb"
import script from "./device-big.vue?vue&type=script&lang=js"
export * from "./device-big.vue?vue&type=script&lang=js"

import "./device-big.vue?vue&type=style&index=0&id=0121aabb&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__